function creatorsConfigDefault(owner) {
  return [{
    address: owner,
    verified: false,
    share: 100
  }];
}

export { creatorsConfigDefault };
//# sourceMappingURL=Creators.mjs.map
